import { useQuery } from "@tanstack/react-query";

import { unreadMessagesCount } from "@/api";

const useGetUnreadMessagesCounter = () => {
  return useQuery({
    queryKey: ["messages-counter"],
    queryFn: unreadMessagesCount,
    meta: { withoutError: true },
  });
};

export { useGetUnreadMessagesCounter };
